import React, {useEffect, useState, useRef, useCallback} from "react";
import circle from "@turf/circle";
import {GoogleMap, Polygon, Marker, OverlayView, Polyline} from '@react-google-maps/api'
import pin from "../../../../../assets/img/placeholder.svg"

const containerStyle = {
    width: '100%',
    height: '400px'
};

const MapComponent = props => {

        const {
            zoom, origen, onDragOrigen, onDragDestination, destination, routes, mapClicked, restrictZoneOrigin,
            restrictZoneDestination, dataCoords, showBounds, setZoom, center,
        } = props

        const [map, setMap] = useState(null)

        const mapRef = useRef();

        const onMapLoad = useCallback((map) => {
            mapRef.current = map;
            setMap(map)
        }, []);

        const onUnmount = useCallback(function callback() {
            setMap(null)
        }, [])

        useEffect(() => {
            if (destination && origen && showBounds) {

                const bounds = new window.google.maps.LatLngBounds();

                const newOrigen = [{lat: origen[0], lng: origen[1]}]
                const newDestination = [{lat: destination[0], lng: destination[1]}]

                const newArray = [...newOrigen, ...newDestination]
                // eslint-disable-next-line array-callback-return
                newArray.map((cords) => {
                    bounds.extend(new window.google.maps.LatLng(cords.lat, cords.lng));

                });

                mapRef.current.fitBounds(bounds)

            } else {
                map && mapRef.current.setZoom(16);
                setZoom(16)
            }
        }, [dataCoords, destination, origen, showBounds, zoom])

        const onIdle = () => {
            showBounds && setZoom(12)
        }

        return (
            <GoogleMap
                zoom={zoom}
                center={center}
                mapContainerStyle={containerStyle}
                onLoad={onMapLoad}
                onIdle={onIdle}
                onUnmount={onUnmount}
                onClick={ev => mapClicked(ev.latLng.lat(), ev.latLng.lng())}
            >
                {origen &&
                <Marker
                    draggable={true}
                    position={{lat: origen[0], lng: origen[1]}}
                    onDragEnd={ev => onDragOrigen(ev.latLng.lat(), ev.latLng.lng())}
                />}

                {destination && <Marker
                    draggable={true}
                    onDragEnd={ev => onDragDestination(ev.latLng.lat(), ev.latLng.lng())}
                    position={{lat: destination[0], lng: destination[1]}}/>}

                {routes &&
                <Polyline
                    path={routes}
                    geodesic={true}
                    options={{
                        strokeColor: "#0F75B3",
                        strokeOpacity: 0.75,
                        strokeWeight: 4,
                    }}/>
                }


                {(restrictZoneOrigin && !showBounds) &&
                <>

                    {restrictZoneOrigin.map((place) => {
                        return (
                            <div key={place.ID}>
                                <Marker key={place.ID}
                                        icon={{
                                            url: pin,
                                            origin: new window.google.maps.Point(0, 0),
                                            anchor: new window.google.maps.Point(15, 15),
                                            scaledSize: new window.google.maps.Size(30, 30),
                                        }}
                                        position={{lat: place.latitude, lng: place.longitude}}/>

                                <OverlayView
                                    position={{lat: place.latitude, lng: place.longitude}}
                                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                >
                                    <div style={style.overlayStyle}>
                                        <span>{place.zone}</span>
                                    </div>
                                </OverlayView>
                            </div>
                        )
                    })}

                </>
                }

                {(restrictZoneDestination && !showBounds) &&
                <>
                    {restrictZoneDestination.map((place) => {
                        return (
                            <div key={place.ID}>
                                <Marker key={place.ID}
                                        icon={{
                                            url: pin,
                                            origin: new window.google.maps.Point(0, 0),
                                            anchor: new window.google.maps.Point(15, 15),
                                            scaledSize: new window.google.maps.Size(30, 30),
                                        }}
                                        position={{lat: place.latitude, lng: place.longitude}}/>

                                <OverlayView
                                    position={{lat: place.latitude, lng: place.longitude}}
                                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                                >
                                    <div style={style.overlayStyle}>
                                        <span>{place.zone}</span>
                                    </div>
                                </OverlayView>
                            </div>
                        )
                    })}
                </>
                }


                {(restrictZoneOrigin && !showBounds) &&
                <>
                    {restrictZoneOrigin.map((zone, i) => {
                        const center = [zone.longitude, zone.latitude];
                        const options = {
                            steps: 25,
                            units: 'kilometers',
                            options: {}
                        }

                        const polygon = circle(center, zone.radius, options);
                        const poly = polygon.geometry.coordinates

                        const polyArray = []
                        poly.forEach(items => {
                            items.forEach(item => {
                                const obj = {lat: item[1], lng: item[0]}
                                polyArray.push(obj)
                            })
                        })
                        return (
                            <Polygon
                                key={i}
                                paths={polyArray}
                                options={{
                                    label: "dsdsd",
                                    text: "asdasdsad",
                                    fillColor: "#ec407a",
                                    fillOpacity: 0.4,
                                    strokeColor: '#e91e63',
                                    strokeOpacity: 1,
                                    strokeWeight: 1
                                }}
                            />
                        )
                    })}
                </>}

                {(restrictZoneDestination && !showBounds) &&
                <>
                    {restrictZoneDestination.map((zone, i) => {
                        const center = [zone.longitude, zone.latitude];
                        const options = {
                            steps: 25,
                            units: 'kilometers',
                            options: {}
                        }

                        const polygon = circle(center, zone.radius, options);
                        const poly = polygon.geometry.coordinates

                        const polyArray = []
                        poly.forEach(items => {
                            items.forEach(item => {
                                const obj = {lat: item[1], lng: item[0]}
                                polyArray.push(obj)
                            })
                        })
                        return (
                            <Polygon
                                key={i}
                                paths={polyArray}
                                options={{
                                    fillColor: "#ec407a",
                                    fillOpacity: 0.4,
                                    strokeColor: '#e91e63',
                                    strokeOpacity: 1,
                                    strokeWeight: 1
                                }}
                            />
                        )
                    })}
                </>}
            </GoogleMap>
        );
    }
;

export default MapComponent;

const style = {
    overlayStyle: {
        width: 50,
        height: 10,
        background: 'rgba(255, 255, 255, 0.8)',
        padding: 5,
        display: "flex",
        flexDirection: 'center',
        alignItems: "center",
        border: '1px solid #333',
        borderRadius: 5,
        marginTop: 15,
    }

}
